// Vendors
import React from 'react';

// Helpers
import { isInWebView } from '../../lib/helpers/nativeWebview';

// STRY0261656: Webview Links not working on Mobile
const SmartLink = ({ href, children, ...props }) => {
  const target = isInWebView() ? '_self' : '_blank';

  return (
    <a href={href} target={target} rel="nooperner noreferrer" {...props}>
      {children}
    </a>
  );
};
export default SmartLink;
